"use strict";

var ReportMap = function () {
  var reportMap = null;
  var mapLayers = null;

  var loadReportMap = async function () {
    Tree.set("mapId", "report");
    const activeGroupId = Tree.get("activeGroup", "groupId");
    const lastGroupId = Tree.get("lastGroupId", "report");
    var firstLoad = false;
    initLayers();

    if (!reportMap) {
      firstLoad = true;
      TreeUpdates.turnOnUpdates(mapLayers, getActiveReportMap, getCurrentReportBasemap, "report");
      reportMap = initReportMap();
      DisplayOptions.startLegendListeners("report", mapLayers);
      loadLayerListenersForReportMap();
      initSimMap();
    }
    const groupChanged = activeGroupId !== lastGroupId;
    if (firstLoad || groupChanged) {
      if (Progeny.activeGroupHasGrandprogeny() && !Progeny.rootGroupIsRegulator()) {
        loadRegionalPointMap();
      } else {
        loadReportMS4Map();
      }
    }

    reloadListeners();
    CommonMapFunctions.afterMapLoad();
  };

  var initLayers = function () {
    if (!mapLayers) {
      mapLayers = LayerFunctions.getAllLayersAsMapLayers();
    }
  };

  var loadLayerListenersForReportMap = function () {
    // @TODO: Set up config to load layer listneres dynamically
    const SbmpProgressLayer = require("../bmpfcs/sbmpProgressLayer");
    SbmpProgressLayer.loadLayerListenersForMap(reportMap, mapLayers, "report");
    const SbmpProgressDrainageLayer = require("../bmpfcs/sbmpProgressDrainageLayer");
    SbmpProgressDrainageLayer.loadLayerListenersForMap(reportMap, mapLayers, "report");
    const FcsProgressLayer = require("../bmpfcs/fcsProgressLayer");
    FcsProgressLayer.loadLayerListenersForMap(reportMap, mapLayers, "report");
    const FcsProgressDrainageLayer = require("../bmpfcs/fcsProgressDrainageLayer");
    FcsProgressDrainageLayer.loadLayerListenersForMap(reportMap, mapLayers, "report");
    const GroundwaterBasinLayer = require("../watershed/groundwaterBasinLayer");
    GroundwaterBasinLayer.loadLayerListenersForMap(reportMap, mapLayers, "report");
    const ConstructionProjectProgressLayer = require("../construction/constructionProjectProgressLayer");
    ConstructionProjectProgressLayer.loadLayerListenersForMap(reportMap, mapLayers, "report");
    const ConstructionProjectAreaProgressLayer = require("../construction/constructionProjectAreaProgressLayer");
    ConstructionProjectAreaProgressLayer.loadLayerListenersForMap(reportMap, mapLayers, "report");
    const IncidentProgressLayer = require("../idde/incidentProgressLayer");
    IncidentProgressLayer.loadLayerListenersForMap(reportMap, mapLayers, "report");
    const OutfallProgressLayer = require("../outfalls/outfallProgressLayer");
    OutfallProgressLayer.loadLayerListenersForMap(reportMap, mapLayers, "report");
    const HighPriorityAreaLayer = require("../idde/highPriorityAreaLayer");
    HighPriorityAreaLayer.loadLayerListenersForMap(reportMap, mapLayers, "report");
    const LidProjectProgressLayer = require("../lid/lidProjectProgressLayer");
    LidProjectProgressLayer.loadLayerListenersForMap(reportMap, mapLayers, "report");
    const LidProjectAreaProgressLayer = require("../lid/lidProjectAreaProgressLayer");
    LidProjectAreaProgressLayer.loadLayerListenersForMap(reportMap, mapLayers, "report");

    const MuniCatchBasinProgressLayer = require("../muni/muniCatchBasinProgressLayer");
    MuniCatchBasinProgressLayer.loadLayerListenersForMap(reportMap, mapLayers, "report");

    const MuniCatchBasinProgressDrainageLayer = require("../muni/muniCatchBasinProgressDrainageLayer");
    MuniCatchBasinProgressDrainageLayer.loadLayerListenersForMap(reportMap, mapLayers, "report");
    const MaintenanceZonesLayer = require("../muni/maintenanceZonesLayer");
    MaintenanceZonesLayer.loadLayerListenersForMap(reportMap, mapLayers, "report");
    const FlowRoutingLayer = require("../outfalls/flowRoutingLayer");
    FlowRoutingLayer.loadLayerListenersForMap(reportMap, mapLayers, "report");
    const OutfallsSimpleLayer = require("../outfalls/outfallsSimpleLayer");
    OutfallsSimpleLayer.loadLayerListenersForMap(reportMap, mapLayers, "report");
    const RunoffProgressLayer = require("../telr/runoffProgressLayer");
    RunoffProgressLayer.loadLayerListenersForMap(reportMap, mapLayers, "report");
    const ParticulatesProgressLayer = require("../telr/particulatesProgressLayer");
    ParticulatesProgressLayer.loadLayerListenersForMap(reportMap, mapLayers, "report");
    const RunoffRatioProgressLayer = require("../telr/runoffRatioProgressLayer");
    RunoffRatioProgressLayer.loadLayerListenersForMap(reportMap, mapLayers, "report");
    RegionPointLayer.loadListeners(reportMap, mapLayers, "report");
    RegionAreaLayer.loadListeners(reportMap, mapLayers, "report");
    const LanduseEsriDynamicMapLayer = require("../general/landuseEsriDynamicMapLayer");
    LanduseEsriDynamicMapLayer.loadLayerListenersForMap(reportMap, mapLayers, "report");
    const StreamsEsriDynamicMapLayer = require("../general/streamsEsriDynamicMapLayer");
    StreamsEsriDynamicMapLayer.loadLayerListenersForMap(reportMap, mapLayers, "report");
    const TrashProgressEsriDynamicMapLayer = require("../trash/trashProgressEsriDynamicMapLayer");
    TrashProgressEsriDynamicMapLayer.loadLayerListenersForMap(reportMap, mapLayers, "report");
  };

  var annualReportingCallback = function () {
    initializeReportLayers();
    // KPI.init(); // @Keep this to investigate duplicate calls issue later
  };

  var loadReportMS4Map = async function () {
    if (Tree.get("annualReportingLoaded")) {
      annualReportingCallback();
    } else {
      await Actions.loadAnnualReporting(annualReportingCallback);
    }

    CommonMapFunctions.afterMS4MapLoad(reportMap);
  };

  var loadRegionalPointMap = function () {
    RegionalView.setRegionalViewDom();
    Ms4Table.loadListeners();
    DataViewFunctions.setDataView("regionPointView");
  };

  var loadRegionalAreaMap = function () {
    RegionalView.setRegionalViewDom();
    Ms4Table.loadListeners();
    DataViewFunctions.setDataView("regionAreaView");
  };

  var reloadListeners = function () {
    Table.loadListeners("report");
    DisplayOptions.startLegendListeners("report", mapLayers);
    CatchmentView.startListeners();

    if (Progeny.activeHasProgeny()) {
      Ms4Table.loadListeners();
    }
  };

  var initializeReportLayers = function () {
    var autoLoadLayers = ["catchments", "ms4Boundary"];
    autoLoadLayers.forEach((layerName) => {
      loadLayer(layerName);
    });
  };

  var loadLayer = function (layerName) {
    switch (layerName) {
      case "catchments":
        Tree.set(["layers", "report", "catchments", "isEnabled"], true);
        break;
      case "ms4Boundary":
        Tree.set(["layers", "report", "ms4Boundary", "isEnabled"], true);
        break;
      case "highways":
        Tree.set(["layers", "report", "highways", "isEnabled"], true);
        break;
    }
  };

  var initSimMap = function () {
    if (!Session.isSalinas()) return;
    SimLayer.main();
  };

  var initReportMap = function () {
    reportMap = L.map("reportMap", {
      zoomControl: false,
      tileLayer: {
        maxNativeZoom: 21,
      },
      minZoom: 3,
      maxZoom: 21,
    });
    CommonMapFunctions.setMapHeight("reportMap", "report");

    var defaultBasemap = DataViewFunctions.getCurrentDataViewProperty("defaultBasemap")["report"];
    mapLayers.basemap = MapFunctions.addBasemap(reportMap, mapLayers.basemap, defaultBasemap);

    L.control
      .scale({
        position: "bottomright",
        metric: false,
      })
      .addTo(reportMap);
    L.control
      .zoom({
        position: "bottomright",
      })
      .addTo(reportMap);
    reportMap.setView(Tree.get("activeGroup", "latlng"), 14);
    MapPaneFunctions.createCustomMapPanes(reportMap);

    return reportMap;
  };

  var getActiveReportMap = function () {
    return reportMap;
  };

  var getActiveLayers = function () {
    initLayers();
    return mapLayers;
  };

  var getCurrentReportBasemap = function () {
    return mapLayers.basemap;
  };

  return {
    loadReportMap,
    loadReportMS4Map,
    loadRegionalAreaMap,
    getActiveLayers,
    getActiveReportMap,
  };
};

module.exports = ReportMap();

const CommonMapFunctions = require("../mapFunctions/commonMapFunctions");
const Tree = require("../../tree");
const Progeny = require("../../login/progeny");
const TreeUpdates = require("../mapFunctions/treeUpdates");
const Table = require("../mapFunctions/table");
const Actions = require("../actions");
const DisplayOptions = require("../mapFunctions/displayOptions");
const CatchmentView = require("../mapFunctions/catchmentView");
const DataViewFunctions = require("../dataViewFunctions");
const Ms4Table = require("../ms4Table");
const RegionPointLayer = require("../general/regionPointLayer");
const RegionAreaLayer = require("../general/regionAreaLayer");
const RegionalView = require("../regionalView");
const LayerFunctions = require("../mapFunctions/layerFunctions");
const MapPaneFunctions = require("../mapFunctions/mapPaneFunctions");
const SimLayer = require("../watershed/simLayer");
const Session = require("../../login/session");
const MapFunctions = require("../mapFunctions/mapFunctions");
